import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { IFaq } from '@propertypal/shared/src/types/strapi';
import Link from 'next/link';
import React from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { QuestionList, QuestionListContainer, QuestionListItem } from './FaqList.style';

interface FaqListProps {
  faqs: IFaq[];
  link: string;
}

const FaqList: React.FC<FaqListProps> = ({ faqs, link }) => {
  return (
    <QuestionListContainer data-testid="faq-list">
      <QuestionList>
        {faqs?.map((s) => (
          <QuestionListItem key={s.id} data-testid="faq-list-item">
            <Link href={`${link}/${s.attributes.slug}`} prefetch={false} data-testid="faq-list-item-link">
              <span>{s.attributes.question}</span>
              <FontAwesomeIcon icon={faChevronRight} />
            </Link>
          </QuestionListItem>
        ))}
      </QuestionList>
    </QuestionListContainer>
  );
};

export default FaqList;
